import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const notices = [{
  name: 'Natalia T.',
  city: 'Mendoza',
  product: 'MegaPack BIO-RESET 5.0'
}, {
  name: 'Gabriela A.',
  city: 'Salta',
  product: 'MegaPack BIO-RESET 5.0'
}, {
  name: 'Verónica D.',
  city: 'Mar del Plata',
  product: 'MegaPack BIO-RESET 5.0'
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % notices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = notices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-202" data-mp="1z7f7j46k7y3i">
      <AnimatePresence data-id="element-203" data-mp="2353389g2tuwg">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} aria-live="polite" className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-2xl bg-white p-4 shadow-lift ring-1 ring-blue-100" data-id="element-204" data-mp="284zachk2m2g8">
            <div className="min-w-0 flex-1" data-id="element-205" data-mp="1p9hhcb553r89">
              <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em] text-gold-700" data-id="element-206" data-mp="rssjstn83b4o">
                <span className="h-2 w-2 rounded-full bg-gold-500" aria-hidden="true" data-id="element-207" data-mp="wpizhfv484pk" />
                Compra verificada
              </p>
              <p className="mt-2 text-sm font-bold text-ink" data-id="element-208" data-mp="1v2y2lquqjved">
                {notice.name} de {notice.city}
              </p>
              <p className="truncate text-sm text-blue-900/70" data-id="element-209" data-mp="28ukyvqooh3x5">
                Compró <span className="font-semibold text-blue-700" data-id="element-210" data-mp="24spx6l2u4oiu">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-blue-900/45" data-id="element-211" data-mp="1h35gk8u5m3cq">hace 2 minutos</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="rounded-md p-1 text-blue-900/40 transition-colors duration-150 ease-calm hover:bg-gold-50 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-300" data-id="element-212" data-mp="1c428sgmshj12">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="31hfh0gy0vr7g" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}